var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.0674 8.13229C22.1644 8.13142 21.2987 7.77234 20.6603 7.13387C20.0218 6.49541 19.6627 5.6297 19.6618 4.72677V0H4.44436C3.26593 -8.13666e-08 2.13573 0.468019 1.3023 1.30114C0.468873 2.13426 0.000437915 3.26427 0 4.4427V31.2343C0.00131311 32.4122 0.470135 33.5414 1.30347 34.3738C2.13681 35.2062 3.2665 35.6737 4.44436 35.6737H22.7106C23.2944 35.674 23.8725 35.5592 24.4119 35.3359C24.9513 35.1127 25.4415 34.7853 25.8543 34.3726C26.2672 33.9599 26.5947 33.4699 26.8182 32.9306C27.0416 32.3912 27.1566 31.8132 27.1566 31.2294V8.13229H23.0674Z",
    fill: "#FF9908"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1567 8.13229H23.0674C22.1645 8.13142 21.2988 7.77234 20.6603 7.13387C20.0218 6.49541 19.6627 5.6297 19.6619 4.72677V0L27.1567 8.13229Z",
    fill: "#FF9908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.379 28.1758H9.72785C8.26296 28.1758 7.07544 29.3633 7.07544 30.8282V36.9852C7.07544 38.4501 8.26296 39.6376 9.72785 39.6376H30.379C31.8439 39.6376 33.0314 38.4501 33.0314 36.9852V30.8282C33.0314 29.3633 31.8439 28.1758 30.379 28.1758Z",
    fill: "#FF9908"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0656 35.2395V36.4402H9.82202V35.2395H11.0656Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4414 31.4739L17.2539 36.4401H15.7675L14.9748 33.1172L14.1738 36.4401H12.6874L11.4999 31.4739H12.8063L13.4454 35.071L14.3174 31.4739H15.6387L16.5107 35.071L17.1565 31.4739H18.4414Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.658 31.5085V36.4401H23.4524V33.3616L22.3838 36.4451H21.345L20.2698 33.355V36.4451H19.0675V31.5135H20.5357L21.8785 34.9487L23.1915 31.5135L24.658 31.5085Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5723 35.5334H26.7027L26.3922 36.4401H25.1288L26.9455 31.5085H28.3295L30.1462 36.4401H28.8679L28.5723 35.5334ZM28.2635 34.6201L27.6441 32.7951L27.0198 34.6201H28.2635Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4307 21.7875H17.6223V14.4777C17.6223 14.2328 17.525 13.998 17.3519 13.8248C17.1787 13.6517 16.9439 13.5544 16.699 13.5544H12.0747C11.8298 13.5544 11.595 13.6517 11.4218 13.8248C11.2487 13.998 11.1514 14.2328 11.1514 14.4777V21.7875H9.33472V13.86C9.33515 13.2983 9.55859 12.7597 9.95593 12.3627C10.3533 11.9657 10.892 11.7427 11.4537 11.7427H17.3019C17.8634 11.7427 18.4019 11.9657 18.799 12.3628C19.1961 12.7599 19.4192 13.2984 19.4192 13.86L19.4307 21.7875Z",
    fill: "#FF9908"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2873 23.9312C18.4712 23.9312 19.431 22.9715 19.431 21.7875C19.431 20.6036 18.4712 19.6438 17.2873 19.6438C16.1033 19.6438 15.1436 20.6036 15.1436 21.7875C15.1436 22.9715 16.1033 23.9312 17.2873 23.9312Z",
    fill: "#FF9908"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01775 23.931C10.2017 23.931 11.1615 22.9712 11.1615 21.7873C11.1615 20.6033 10.2017 19.6436 9.01775 19.6436C7.8338 19.6436 6.87402 20.6033 6.87402 21.7873C6.87402 22.9712 7.8338 23.931 9.01775 23.931Z",
    fill: "#FF9908"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWma);
export default __webpack_public_path__ + "static/media/wma.6341b04d364a6b536f994f3dd26d77c4.svg";
export { ForwardRef as ReactComponent };